<template>
    <div class="grid grid-cols-2 gap-4">
        <div v-for="(search, index) in $page.props.queryBuilderProps.search" :key="index"
            :class="'col-span-' + search.config.position"
        >
            <jet-label :for="search.label" :value="search.label" />
            <jet-input
                :id="search.label"
                :type="search.config.type"
                :value="search.value"
                :placeholder="search.config.placeholder"
                :min="search.config.min"
                :class="search.config.class"
                @input="changeSearchValue(index, $event.target.value)"
            />
        </div>
        <div v-for="(filter, index) in $page.props.queryBuilderProps.filters" :key="index"
            :class="'col-span-' + filter.config.position"
        >
            <jet-label :value="filter.label"/>
            <multiselect
                searchable
                :ref="index"
                v-model="select[index]"
                :options="filter.options"
                :mode="filter.config.mode"
                @change="changeFilterValue(index)"
                :placeholder="filter.config.placeholder"
            />
        </div>
        <div class="col-span-2 text-right">
            <boti-button @click="search" text="Rechercher" color="sky">
                <template #icon><i class="fad fa-search text-xs ml-1"></i></template>
            </boti-button>
        </div>
    </div>
</template>

<script>
    import qs from "qs"
    import JetLabel from '@/Jetstream/Label'
    import JetInput from '@/Jetstream/Input'
    import BotiButton from '@/Components/Button'
    import Multiselect from '@vueform/multiselect'
    import InteractWIthFilterMixins from "@/Mixins/InteractWIthFilterMixins";

    export default {
        components: {
            JetLabel,
            JetInput,
            BotiButton,
            Multiselect
        },

        mixins: [InteractWIthFilterMixins],

        data() {
            return {
                select: {
                }
            }
        },

        mounted() {
            this.fillSelectModel()

            if (window.location.search) {
                this.setFormFields()
            }
        },

        methods: {
            fillSelectModel() {
                for (const [key, value] of Object.entries(this.$page.props.queryBuilderProps.filters)) {
                    this.select[key] = value.config.mode === 'tags' ? [] : null
                }
            },
            setFormFields() {
                const params = qs.parse(window.location.search.substring(1))
                if (params.filter) {
                    for (const [key, value] of Object.entries(params.filter)) {
                        if (this.$page.props.queryBuilderProps.search[key]) {
                            this.$page.props.queryBuilderProps.search[key].value = value
                        }

                        if (this.$page.props.queryBuilderProps.filters[key]) {
                            let filterValue = ''
                            if (this.$page.props.queryBuilderProps.filters[key].config.mode === 'tags') {
                                filterValue = value.split(',')
                            } else {
                                filterValue =  value
                            }

                            this.select[key] = filterValue
                            this.$refs[key].textValue = filterValue
                            this.$page.props.queryBuilderProps.filters[key].value = filterValue
                        }
                    }
                }
            },
        }
    }
</script>
